define(function (require) {
	const Big = require('civicsUtils/libraries/big');
    return {
        coordsToFeature(coords) {
          var feature;
              if ( _.isArray(coords)){
                var x;
                var y;
                if ( coords.length == 2 ){
                  x = coords[0];
                  y = coords[1];
                }
                else {
                  x = (coords[0] + coords[2])/2;
                  y = (coords[1] + coords[3])/2;
                }
                if ( x!= undefined && y!=undefined){
                  feature = {};
                  feature.attributes={"lon":x,"lat":y,"zoom":"19","geometryType":"Point"};
                  feature.geometryType = "point";
                  feature.geometry = [];
                  feature.geometry.push(x);
                  feature.geometry.push(y);
                }
              }
              return feature;
        },
        processMapModel:function(attr){
          attr.id = null;
          attr.type = '';
          attr.GISModel = true;
          if((attr.syncEventType && attr.syncEventType == 'parcel') || attr.PRCLKEY || attr.PRCLKEY === 0){//if it's a parcel
            if( attr.PRCLKEY > 1){//if it's in Hansen, it will have a PRCLKEY > 1. not in hansen, we don't want an ID
              attr.id = 'parcel' + attr.PRCLKEY
			  } else {
				  attr.nonHansenSite = true;
			  }

            attr.type='parcel'
            attr.parcelId = attr.PRCLID
          } else if((attr.syncEventType && attr.syncEventType == 'address') || attr.ADDRKEY  || attr.ADDRKEY === 0){//,if it's an Address
            if(attr.ADDRKEY > 1){// if it's in hansen, it will have an ADDRKEY>1
              attr.id = 'address' + attr.ADDRKEY
			} else {
				attr.nonHansenSite = true;
			}
            attr.type = 'address'
          } else if(attr.geometryType && attr.geometryType.toLowerCase() == 'point'
            && attr.lat != undefined
            && attr.lon != undefined){
            attr.id = 'coord'+attr.lat+attr.lon;
            attr.type = 'coords';
          }else {
            //todo need to work with corey on how to handle this
          }
          return attr;
		},
		buildExtentFromPoint: function (x, y, extentSize) {
			//when creating the extent, note that this isn't an exact science. the distances will change the further north or south you are. These general values are averages.
			//the first decimal place is worth up to 11km of distance
			//the second decimal place is worth up to 1.1km of distance
			//the third decimal place is worth up to 110 meters.
			//the fourth is worth up to 11m
			//since the position of the location on the globe affects the value, 
			//we can't get overly prescriptive here.
			//adding and subtracting .001 to get a min x and y may then be expected to 
			//create a roughly 220m square extent
			var x = new Big(x);
			var y = new Big(y);

			var extent = {
				min: {
					x: (x.minus(extentSize)).toString(),
					y: (y.minus(extentSize)).toString()
				},
				max: {
					x: (x.plus(extentSize)).toString(),
					y: (y.plus(extentSize)).toString()
				}
			};
			//console.log(extent);
			return extent;
		},
		//note this distance is just for comparison. there are no units (km/m) attached.
		distance: function (lat1, lon1, lat2, lon2) {
			if ((lat1 == lat2) && (lon1 == lon2)) {
				return 0;
			}
			else {
				var radlat1 = Math.PI * lat1 / 180;
				var radlat2 = Math.PI * lat2 / 180;
				var theta = lon1 - lon2;
				var radtheta = Math.PI * theta / 180;
				var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
				if (dist > 1) {
					dist = 1;
				}
				dist = Math.acos(dist);
				dist = dist * 180 / Math.PI;
				dist = dist * 60 * 1.1515;
				return dist;
			}
		},
		findClosestSite: function (point, data) {
			//we need to find the closest site in the array. the reduce function loops through the array adn the
			//accumulator is the only value that is maintained. Because the distance calculation is expensive, 
			//using reduce lowers the number of times it's called vs calling sort
			let closest = data.reduce((accumulator, site) => {
				if (site.Spatial && site.Spatial.yCoordinate && site.Spatial.xCoordinate) {
					var dist = mapUtils.distance(point.y, point.x, site.Spatial.yCoordinate, site.Spatial.xCoordinate);
					site.distance = dist;
					return dist > accumulator.distance ? accumulator : site;
				}
				return accumulator;
			}, {});
			return closest;
		},
		sortSitesByDistance: function (point, data) {	
			data.sort((a, b) => {
				const { xCoordinate: ax, yCoordinate: ay } = a.Spatial;
				const { xCoordinate: bx, yCoordinate: by } = b.Spatial;
				//temporary code for debugging
				a._distanceToPoint = a._distanceToPoint ? a._distanceToPoint : this.distance(point.y, point.x, ay, ax);
				b._distanceToPoint = b._distanceToPoint ? b._distanceToPoint : this.distance(point.y, point.x, by, bx)
				return a._distanceToPoint - b._distanceToPoint; 
			})
			return data;
		},
		//from wizard widget -> this formats selected location value to its site description
		formatSiteDescription: function(value) {
			try {
				var j = JSON.parse(value);
				if ( j !== null && typeof j === "object" ){
					if ( j.snapshot) {
					  return new Handlebars.SafeString('<img src="'+j.snapshot+'"></img>');
					}
					else if (j.attributes){
						if ( j.attributes.ADDRKEY ){
							value = "{0} {1}".format( j.attributes.locationLine1,j.attributes.locationLine2 );
						}
						else if ( j.attributes.PRCLID ){
							value = j.attributes.PRCLID;
						}
						else if ( j.attributes.lon && j.attributes.lat){
							value = '↔ {0} ↕ {1}	'.format(j.attributes.lon, j.attributes.lat);
						}
					}
				}
			} catch (e) {}
			if ( !value || value.length == 0 ){
				value = 'Not Yet Answered';
			}
			return value;
		}

    };
});
